module.exports = __webpack_public_path__ + "img/VALOR_RESPONSABILIDAD1.83ccee4d.png";